module.exports = __webpack_public_path__ + "img/folietape.29912f62.jpg";